/* eslint-disable import/no-cycle */
import { handleActions } from 'redux-actions';
import { workflow } from '../../../config/routeconfig';
import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';

const workflowSteps = workflow.getWorkflowSteps();

export const initialState = {
  activeStepIndex: 0,
  activeMainStepIndex: 0,
  steps: workflowSteps,
  completedSteps: [],
  isBlocked: false,
  isSuccess: false,
  Message: null,
  activeStepLinks: null,
  nextStepLinks: null,
  isIdVerificationAttemptsMaxed: false,
};

const reducer = handleActions(
  {
    [actionTypes.UPDATE_NEXT_STEP]: (state, { payload }) => ({
      ...state,
      steps: payload.steps,
      activeStepIndex: payload.activeStepIndex,
      activeMainStepIndex: payload.activeMainStepIndex,
      activeStepLinks: state.nextStepLinks,
      nextStepLinks: null,
    }),
    [actionTypes.MARK_CURRENT_STEP_AS_COMPLETED]: (state, { payload }) => {
      const completedSteps = state.completedSteps;
      completedSteps.push(state.activeStepIndex);

      return {
        ...state,
        completedSteps,
        nextStepLinks: payload.nextStepLinks,
      };
    },
    [actionTypes.UPDATE_WORKFLOW_STEPS]: (state, { payload }) => ({
      ...state,
      workflow: payload,
    }),
    [actionTypes.DIVERT_PROGRESS]: (state, { payload }) => ({
      ...state,
      isBlocked: payload.isBlocked,
      isSuccess: payload.isSuccess,
      message: payload.message,
    }),
    [actionTypes.ID_VERIFICATION_MAXED]: (state, { payload }) => ({
      ...state,
      isIdVerificationAttemptsMaxed: payload.isIdVerificationAttemptsMaxed,
    }),
    [actionTypes.RESET_CURRENT_STEP]: (state) => {
      const completedSteps = state.completedSteps;
      completedSteps.pop();

      return {
        ...state,
        completedSteps,
      };
    },
    [actionTypes.APPEND_TO_ACTIVE_STEP_LINKS]: (state, { payload }) => {
      const activeStepLinks = state.activeStepLinks.concat(payload);
      return {
        ...state,
        activeStepLinks,
      };
    },
    [actionTypes.GLOBAL_RESET]: () => ({
      ...initialState,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX),
);

export default reducer;
